module.exports = __webpack_public_path__ + "static/media/Sunny_Friendly.917700e5.gif";